export { default } from './RegisterPageContainer'